// extracted by mini-css-extract-plugin
export default {"list":"IngredientsList_list__IBTdD"};